import React, { Component } from "react";
import "./ExpiredPage.css";

class ExpiredPage extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }
    render() {
        return (
            <div className="general">
                <img className="veriff-logo-with-name" alt="veriff-logo" src="/veriff-logo-with-text.png" />

                <div className="message">
                    <div className="title">Expired Link</div>
                    <div className="desc">
                        <p>
                            {" "}
                            This link has expired. <br></br>
                            If you still need it , please contact us.
                        </p>
                    </div>
                </div>
            </div>
        );
    }
}

export default ExpiredPage;
